<template>
  <div v-if="user_has_closed != 'true'" class="banner-container">
    <p>¡NUEVA MASTERCLASS! <strong>El 05 de Mayo a las 20:00</strong> (hora peninsular) tienes una cita con Eurekers. ¡No te lo pierdas!.</p>
    <span class="material-icons-outlined close-icon-banner" @click="_closeBanner()">close</span>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import APICaller from "@/components/codeComponents/APICaller.js";

export default {
name: 'Banner',
mixins: [APICaller],
data() {
  return {
    user_has_closed: 'true',
  };
},
watch: {
  
},
mounted() {
  var bannerInterval = setInterval(() => {
    if (this._g_UserId != undefined && this._g_UserId != 0 && this._g_UserId != null) {
      this._getIfUserClosedBanner();
      clearInterval(bannerInterval);
    }
  }, 250);
},
computed: {
  ...mapGetters(['_g_IsUserLogged', '_g_UserId'])
},
methods: {
  _getIfUserClosedBanner: function(){
    this.user_has_closed = sessionStorage.getItem('masterclass-banner');
  },

  _closeBanner: function(){
    this.user_has_closed = "true"
    sessionStorage.setItem('masterclass-banner', 'true');
  }
},
}
</script>

<style lang="scss">
.banner-container{
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: rgb(216, 171, 24);
  color: white;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 998;
  padding: 10px 15px;
  
  p {
    margin: 0;
    flex: 1;
    text-align: center;
  }
}

.close-icon-banner{
  cursor: pointer;
  margin-left: 20px;
}
</style>
